'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var react = require('@chakra-ui/react');
require('../../../icons/AccountAdd.js');
require('../../../icons/AccountCheck.js');
require('../../../icons/AccountRemove.js');
require('../../../icons/AccountStar.js');
require('../../../icons/Account.js');
require('../../../icons/ArrowCollapse.js');
require('../../../icons/ArrowDownDrop.js');
require('../../../icons/ArrowExpand.js');
require('../../../icons/ArrowLeftDrop.js');
require('../../../icons/ArrowLeft.js');
require('../../../icons/ArrowRightDrop.js');
require('../../../icons/Bell.js');
require('../../../icons/BullhornOutline.js');
require('../../../icons/BurgerMenu.js');
require('../../../icons/CalendarDetailed.js');
require('../../../icons/CalendarOutline.js');
require('../../../icons/CashOff.js');
require('../../../icons/Cash.js');
require('../../../icons/CautionDecagram.js');
require('../../../icons/CautionOutline.js');
require('../../../icons/CheckCircled.js');
require('../../../icons/CheckDecagram.js');
require('../../../icons/CheckOutlinedCircled.js');
require('../../../icons/Check.js');
require('../../../icons/ChevronDown.js');
require('../../../icons/ChevronLeft.js');
require('../../../icons/ChevronRight.js');
require('../../../icons/ChevronUp.js');
require('../../../icons/CircleOutline.js');
require('../../../icons/ClipboardTextOutline.js');
require('../../../icons/Clock.js');
require('../../../icons/CloseCircleFilled.js');
var Close = require('../../../icons/Close.js');
require('../../../icons/CompareArrows.js');
require('../../../icons/Corner.js');
require('../../../icons/Critical.js');
require('../../../icons/Delete.js');
require('../../../icons/DocumentEditCircled.js');
require('../../../icons/DocumentEditOutline.js');
require('../../../icons/DotsVertical.js');
require('../../../icons/DownloadFilled.js');
require('../../../icons/Draft.js');
require('../../../icons/Encryption.js');
require('../../../icons/EuroOff.js');
require('../../../icons/Euro.js');
require('../../../icons/EyeOff.js');
require('../../../icons/Eye.js');
require('../../../icons/FlagCheckered.js');
require('../../../icons/FwSet0Constructionyear1.js');
require('../../../icons/FwSet0Constructionyear2.js');
require('../../../icons/FwSet0Constructionyear3.js');
require('../../../icons/FwSet0Constructionyear4.js');
require('../../../icons/FwSet0Corner.js');
require('../../../icons/FwSet0Corneretc.js');
require('../../../icons/FwSet0CultivableLimited.js');
require('../../../icons/FwSet0CultivableNo.js');
require('../../../icons/FwSet0CultivableUnsure.js');
require('../../../icons/FwSet0Cultivable.js');
require('../../../icons/FwSet0ElevatorNo.js');
require('../../../icons/FwSet0Elevator.js');
require('../../../icons/FwSet0Flat.js');
require('../../../icons/FwSet0Garage.js');
require('../../../icons/FwSet0House.js');
require('../../../icons/FwSet0IndustryDontKnow.js');
require('../../../icons/FwSet0IndustryIndustry.js');
require('../../../icons/FwSet0IndustryLiveBusiness.js');
require('../../../icons/FwSet0IndustryOffice.js');
require('../../../icons/FwSet0Industry.js');
require('../../../icons/FwSet0KitchenNew.js');
require('../../../icons/FwSet0KitchenNo.js');
require('../../../icons/FwSet0KitchenOld.js');
require('../../../icons/FwSet0LandDevelopmentFull.js');
require('../../../icons/FwSet0LandDevelopmentInPart.js');
require('../../../icons/FwSet0LandDevelopmentNo.js');
require('../../../icons/FwSet0Level1.js');
require('../../../icons/FwSet0Level2.js');
require('../../../icons/FwSet0Level3.js');
require('../../../icons/FwSet0Levelplus.js');
require('../../../icons/FwSet0LivingspaceUnknown.js');
require('../../../icons/FwSet0Livingspace100.js');
require('../../../icons/FwSet0Livingspace200.js');
require('../../../icons/FwSet0Livingspace200Plus.js');
require('../../../icons/FwSet0ParkingNo.js');
require('../../../icons/FwSet0Parking.js');
require('../../../icons/FwSet0PlotUnknown.js');
require('../../../icons/FwSet0Plot.js');
require('../../../icons/FwSet0Plot1000.js');
require('../../../icons/FwSet0Plot1000Plus.js');
require('../../../icons/FwSet0Plot300.js');
require('../../../icons/FwSet0Rooms.js');
require('../../../icons/FwSet0SemiDetached.js');
require('../../../icons/FwSet0TownhouseCorner.js');
require('../../../icons/FwSet0TownhouseMiddle.js');
require('../../../icons/GiftCircled.js');
require('../../../icons/Hausgold.js');
require('../../../icons/HelpOutline.js');
require('../../../icons/Help.js');
require('../../../icons/HomeOutline.js');
require('../../../icons/HouseCircled.js');
require('../../../icons/HousePerson.js');
require('../../../icons/House.js');
require('../../../icons/Industry.js');
require('../../../icons/InfoFilled.js');
require('../../../icons/InfoOutline.js');
require('../../../icons/LabelPercent.js');
require('../../../icons/Level2.js');
require('../../../icons/LightbulbOn.js');
require('../../../icons/LockCircledOutline.js');
require('../../../icons/Lock.js');
require('../../../icons/Magnifier.js');
require('../../../icons/Mail.js');
require('../../../icons/Map.js');
require('../../../icons/MissingOutline.js');
require('../../../icons/OkCircled.js');
require('../../../icons/OpenBookOutline.js');
require('../../../icons/PageFirst.js');
require('../../../icons/PageLast.js');
require('../../../icons/Pause.js');
require('../../../icons/Pen.js');
require('../../../icons/Percent.js');
require('../../../icons/PhoneCircled.js');
require('../../../icons/Phone.js');
require('../../../icons/PiggyBankCircled.js');
require('../../../icons/PiggyBank.js');
require('../../../icons/Plus.js');
require('../../../icons/PremiumStars.js');
require('../../../icons/Printer.js');
require('../../../icons/RealtyCommercial.js');
require('../../../icons/RealtyFlat.js');
require('../../../icons/RealtyHouse.js');
require('../../../icons/RealtySite.js');
require('../../../icons/Rocket.js');
require('../../../icons/Rooms.js');
require('../../../icons/SpeechBubble.js');
require('../../../icons/SpeechBubbles.js');
require('../../../icons/Speedometer.js');
require('../../../icons/Star.js');
require('../../../icons/StatusDontknow.js');
require('../../../icons/SwapHorizontalBold.js');
require('../../../icons/ThumbDownOutline.js');
require('../../../icons/ThumbUpOutline.js');
require('../../../icons/TruckFastOutline.js');
require('../../../icons/UnorderedList.js');
require('../../../icons/User.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Customizes `react-select`'s ClearIndicator.
 * Check out https://react-select.com/components to read more!
 */
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({}, innerProps, {
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }), children || /*#__PURE__*/React__default["default"].createElement(Close.Close, null));
};
exports["default"] = ClearIndicator;